
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, User, FileText, Lock } from "lucide-react";
import PasswordChangeDialog from "./PasswordChangeDialog";

const SafetySection = () => {
  const navigate = useNavigate();
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);

  return (
    <Card className="bg-gray-900/80 border-gray-600">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-ice-white">
          <Shield className="w-5 h-5 text-pink-500" />
          Safety & Security
        </CardTitle>
        <CardDescription className="text-gray-300">
          Keep your account safe and secure
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => setPasswordDialogOpen(true)}
        >
          <Lock className="w-4 h-4 mr-2" />
          Change Password
        </Button>
        <Button variant="outline" className="w-full justify-start">
          <Shield className="w-4 h-4 mr-2" />
          Two-Factor Authentication
        </Button>
        <Button variant="outline" className="w-full justify-start">
          <User className="w-4 h-4 mr-2" />
          Blocked Users
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => navigate('/terms-of-service')}
        >
          <FileText className="w-4 h-4 mr-2" />
          Terms of Service
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={() => navigate('/privacy-policy')}
        >
          <Shield className="w-4 h-4 mr-2" />
          Privacy Policy
        </Button>
      </CardContent>
      
      <PasswordChangeDialog 
        open={passwordDialogOpen}
        onOpenChange={setPasswordDialogOpen}
      />
    </Card>
  );
};

export default SafetySection;
